import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import SpartanHome from "../views/SpartanHome.vue";
import SpartanBio from "../views/SpartanBio.vue";
import SpartanWorkOrder from "../views/SpartanWorkOrder.vue";
import SpartanContact from "../views/SpartanContact.vue";
import ShieldHome from "../views/ShieldHome.vue";
import ShieldBios from "../views/ShieldBios.vue";
import ShieldAboutServices from "../views/ShieldAboutServices.vue";
import ShieldContact from "../views/ShieldContact.vue";
import SpartanIntro from "../views/SpartanIntro.vue";
import ShieldIntro from "../views/ShieldIntro.vue";
import ShieldContactSuccess from "../views/ShieldContactSuccess";
import SpartanContactSuccess from "../views/SpartanContactSuccess";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: 'Spartan Builders | Shield Maintenance'
    }
  },
  {
    path: "/intro",
    name: "Home",
    component: Home
  },
  {
    path: "/intro",
    name: "Intro",
    component: Home
  },
  {
    path: "/spartan",
    name: "spartanHome",
    component: SpartanHome,
    meta: {
      title: 'Spartan Builders'
    }
  },
  {
    path: "/spartan-intro",
    name: "spartanIntro",
    component: SpartanIntro,
    meta: {
      title: 'Spartan Builders'
    }
  },
  {
    path: "/shield-intro",
    name: "shieldIntro",
    component: ShieldIntro,
    meta: {
      title: 'Shield Maintenance'
    }
  },
  {
    path: "/spartan/bio",
    name: "spartan-bio",
    component: SpartanBio,
    meta: {
      title: 'Spartan Builders - Bio'
    }
  },
  {
    path: "/spartan/work-order",
    name: "spartan-work-order",
    component: SpartanWorkOrder,
    meta: {
      title: 'Spartan Builders - Work Order'
    }
  },
  {
    path: "/spartan/contact",
    name: "spartan-contact",
    component: SpartanContact,
    meta: {
      title: 'Spartan Builders - Contact Us'
    }
  },
  {
    path: "/shield",
    name: "shield-home",
    component: ShieldHome,
    meta: {
      title: 'Shield Maintenance'
    }
  },
  {
    path: "/shield/bios",
    name: "shield-bios",
    component: ShieldBios,
    meta: {
      title: 'Shield Maintenance - Bios'
    }
  },
  {
    path: "/shield/about-services",
    name: "shield-about-services",
    component: ShieldAboutServices,
    meta: {
      title: 'Shield Maintenance - About Us and Services'
    }
  },
  {
    path: "/shield/contact",
    name: "shield-contact",
    component: ShieldContact,
    meta: {
      title: 'Shield Maintenance - Contact Us'
    }
  },
  {
    path: "/shield/success",
    name: "shield-contact-success",
    component: ShieldContactSuccess,
    meta: {
      title: 'Shield Maintenance'
    }
  },
  {
    path: "/spartan/success",
    name: "spartan-contact-success",
    component: SpartanContactSuccess,
    meta: {
      title: 'Spartan Builders'
    }
  }
  // {
  //   path: "/spartan/work-order",
  //   name: "spartanWorkOder",
  //   component: SpartanWorkOrder
  // },
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
